module.exports = __webpack_public_path__ + "78bb16939adff485912d0245ecf36ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-5.png
// module id = 409
// module chunks = 0